<template>

    <el-menu style="border: none !important;" class="el-menu-demo" mode="horizontal" :ellipsis="false"
        background-color="#000000" text-color="#fff" @select="handleSelect">
        <div class="nav-el-radio"
            style="height: fit-content;font-weight: bold;margin-top: 1rem;margin-left: 0.5rem;color:white"
            @click="toggleCollapse()">
            <span v-if="isCollapse1 == 1 && isWindow" class="iconfont icon-zhedie-shouqi"></span>
            <span v-else-if="isCollapse1 == 0 && !isWindow" class="iconfont icon-zhedie-shouqi"></span>
            <span v-else-if="isCollapse1 == 0 && isWindow" class="iconfont icon-zhedie-zhankai"></span>
            <span v-else class="iconfont icon-zhedie-zhankai"></span>
        </div>
        <el-sub-menu style="right: 0;position: absolute;" index="1">
            <template #title>{{ user_conf.user_email?(user_conf.username?user_conf.username:"未设置"):"未登录" }}</template>
            <el-menu-item index="1-1" class="ml-2" @click="navigateTo('/')"><span class="iconfont icon-gerenziliao2"
                    style="font-size: 1.1rem !important;margin-right: 8px;"></span>个人资料</el-menu-item>
            <el-menu-item index="1-2" class="ml-2" @click="navigateTo('/userLog')"><span class="iconfont icon-rizhi"
                    style="font-size: 1.1rem !important;margin-right: 8px;"></span>用户日志</el-menu-item>
            <el-menu-item index="1-3" class="ml-2" @click="navigateTo('/dockKey')"><span class="iconfont icon-jiekou"
                    style="font-size: 1.1rem !important;margin-right: 8px;"></span>对接密钥</el-menu-item>
            <el-menu-item index="1-4" class="ml-2" @click="outLogin()"> <span class="iconfont icon-tuichu1"
                    style="margin-right: 7px;margin-left: 3px;"></span>退出</el-menu-item>
        </el-sub-menu>
    </el-menu>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';
var isWindow = window.innerWidth > 768;
const activeIndex = ref('1')
const user_conf = ref(JSON.parse(localStorage.getItem("user_conf") || "{}"));
const handleSelect = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
const store = useStore();


var isCollapse1 = ref(store.getters.isCollapse);
if (localStorage.getItem("isCollapse") == "-1") {
    store.commit('setIsCollapse', -1);
    isCollapse1.value = -1;
} else if (localStorage.getItem("isCollapse") == "1") {
    store.commit('setIsCollapse', 1);
    isCollapse1.value = 1;
} else {
    store.commit('setIsCollapse', 0);
    isCollapse1.value = 0;
}
// 处理点击事件以切换折叠状态
const toggleCollapse = () => {
    if (isCollapse1.value == 1) {
        isCollapse1.value = 0;
    } else if (isCollapse1.value == 0) {
        if (isWindow) {
            isCollapse1.value = 1;
        } else {
            isCollapse1.value = -1;
        }
    } else {
        isCollapse1.value = 0;
    }
    store.commit('setIsCollapse', isCollapse1.value);
    localStorage.setItem('isCollapse', isCollapse1.value);
};
const router = useRouter();
const navigateTo = (path: string) => {
    store.dispatch('setIsCollapse', isCollapse1.value);
    router.push(path);

}
const outLogin = () => {
    ElMessageBox.confirm(
        '您确定要退出登录吗？',
        'Warning',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("user_conf");
            ElMessage.success("退出登录成功")
            setTimeout(() => {
                location.reload();
            }, 1000);
        })
        .catch(() => {
            console.log();
        })
}

</script>

<style>
.el-menu--horizontal>.el-menu-item:nth-child(1) {
    margin-right: auto;
}
</style>